// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2eBGg","colMaxWidth":"Table_colMaxWidth__2IHje"};